import { render, staticRenderFns } from "./game-galaxsys.vue?vue&type=template&id=15774ebd&scoped=true"
import script from "./game-galaxsys.vue?vue&type=script&lang=js"
export * from "./game-galaxsys.vue?vue&type=script&lang=js"
import style0 from "./game-galaxsys.vue?vue&type=style&index=0&id=15774ebd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15774ebd",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-galaxsys.vue
// module id = c5rp
// module chunks = 0